// src/components/admin/MapLayerPanel.js
import React from 'react';
import { X, Layers, Activity, Thermometer, Navigation, Bike, DollarSign, Eye, EyeOff } from 'lucide-react';
import './MapLayerPanel.css';

function MapLayerPanel({
  onClose,
  showTraffic,
  setShowTraffic,
  showHeatmap,
  setShowHeatmap,
  showWeather,
  setShowWeather,
  showTransit,
  setShowTransit,
  showBicycle,
  setShowBicycle,
  showTolls,
  setShowTolls,
  showLabels,
  setShowLabels,
  showPOI,
  setShowPOI,
  showIdleVehicles,
  setShowIdleVehicles,
  showMovingVehicles,
  setShowMovingVehicles,
  showStoppedVehicles,
  setShowStoppedVehicles,
  showOfflineVehicles,
  setShowOfflineVehicles
}) {
  return (
    <div className="layer-panel">
      <div className="layer-panel-header">
        <h3>Map Layers & Filters</h3>
        <button className="close-btn" onClick={onClose}>
          <X size={20} />
        </button>
      </div>
      
      <div className="layer-section">
        <h4>Map Layers</h4>
        <div className="layer-controls">
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showTraffic}
                onChange={() => setShowTraffic(!showTraffic)}
              />
              <Activity size={16} />
              <span>Traffic</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showHeatmap}
                onChange={() => setShowHeatmap(!showHeatmap)}
              />
              <Thermometer size={16} />
              <span>Heatmap</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showTransit}
                onChange={() => setShowTransit(!showTransit)}
              />
              <Navigation size={16} />
              <span>Transit</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showBicycle}
                onChange={() => setShowBicycle(!showBicycle)}
              />
              <Bike size={16} />
              <span>Bicycle</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showTolls}
                onChange={() => setShowTolls(!showTolls)}
              />
              <DollarSign size={16} />
              <span>Tolls</span>
            </label>
          </div>
        </div>
      </div>
      
      <div className="layer-section">
        <h4>Map Display</h4>
        <div className="layer-controls">
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showLabels}
                onChange={() => setShowLabels(!showLabels)}
              />
              <Eye size={16} />
              <span>Labels</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showPOI}
                onChange={() => setShowPOI(!showPOI)}
              />
              <Eye size={16} />
              <span>Points of Interest</span>
            </label>
          </div>
        </div>
      </div>
      
      <div className="layer-section">
        <h4>Vehicle Filters</h4>
        <div className="layer-controls">
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showMovingVehicles}
                onChange={() => setShowMovingVehicles(!showMovingVehicles)}
              />
              <Navigation size={16} />
              <span>Moving Vehicles</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showIdleVehicles}
                onChange={() => setShowIdleVehicles(!showIdleVehicles)}
              />
              <Layers size={16} />
              <span>Idle Vehicles</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showStoppedVehicles}
                onChange={() => setShowStoppedVehicles(!showStoppedVehicles)}
              />
              <EyeOff size={16} />
              <span>Stopped Vehicles</span>
            </label>
          </div>
          
          <div className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={showOfflineVehicles}
                onChange={() => setShowOfflineVehicles(!showOfflineVehicles)}
              />
              <EyeOff size={16} />
              <span>Offline Vehicles</span>
            </label>
          </div>
        </div>
      </div>
      
      <div className="layer-panel-footer">
        <button className="apply-btn" onClick={onClose}>
          Apply Changes
        </button>
      </div>
    </div>
  );
}

export default MapLayerPanel;